import { MasterAccountInfo } from 'ctp-user-auth-service';
import { InstanceCreation } from 'ctp-toll-domain';
import { ActionTree } from 'vuex';
import {
  DatInstancesState,
  CREATE_DAT_INSTANCE,
  ARCHIVE_DELETE_DAT_INSTANCE,
  FETCH_DAT_INSTANCES,
  SET_ERROR,
  SET_NOTIFICATION,
  UPDATE_DAT_INSTANCES_STATE
} from './types';
import { InstancesApiCaller as InstancesApi } from './caller';

const actions: ActionTree<DatInstancesState, Record<string, never>> = {
  [CREATE_DAT_INSTANCE]({ commit }, payload: InstanceCreation): Promise<void> {
    return InstancesApi.createInstanceV2(payload).then((response) => {
      if (response) {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'success', code: 200, content: 'map.tolldomains.dsrc_instances.created'
        });
      } else {
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: 500, content: 'map.tolldomains.dsrc_instances.critical'
        });
      }
    }).catch((response: Response) => {
      response.text().then((text) => {
        const res = JSON.parse(text);
        const content = res.code ? `common.error.${res.code}` : res;
        commit(SET_NOTIFICATION, {
          notificationStatus: 'error', code: response.status, content, field: res.message
        });
      });
    });
  },
  [ARCHIVE_DELETE_DAT_INSTANCE]({ commit }, payload): Promise<void> {
    return InstancesApi.deleteInstance(payload.eid, payload.masterId, payload.archiving).then(() => {
      commit(SET_NOTIFICATION, {
        notificationStatus: 'success', code: 200, content: payload.archiving ? 'map.tolldomains.dsrc_instances.archived' : 'map.tolldomains.dsrc_instances.deleted'
      });
    }).catch(() => {
      commit(SET_NOTIFICATION, {
        notificationStatus: 'error', code: 500, content: 'map.tolldomains.dsrc_instances.critical'
      });
    });
  },
  [FETCH_DAT_INSTANCES]({ commit }, payload: MasterAccountInfo): Promise<void> {
    commit(UPDATE_DAT_INSTANCES_STATE, {
      view: 'instances',
      stateKey: 'loading',
      stateValue: true
    });
    commit(UPDATE_DAT_INSTANCES_STATE, {
      view: 'instances',
      stateKey: 'fetched',
      stateValue: false
    });
    commit(UPDATE_DAT_INSTANCES_STATE, {
      view: 'instances',
      stateKey: 'error',
      stateValue: false
    });
    return InstancesApi.getInstancesV2(payload.id)
      .then((res) => {
        commit(FETCH_DAT_INSTANCES, res);
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'fetched',
          stateValue: true
        });
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'loading',
          stateValue: false
        });
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'error',
          stateValue: false
        });
      })
      .catch((res) => {
        commit(SET_ERROR, res.message);
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'error',
          stateValue: true
        });
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'fetched',
          stateValue: false
        });
        commit(UPDATE_DAT_INSTANCES_STATE, {
          view: 'instances',
          stateKey: 'loading',
          stateValue: false
        });
      });
  }
};
export default actions;
